export default __webpack_public_path__ + "static/media/type-alert.37f1c5b1.svg";